import { compose } from 'lodash/fp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hasFeatureFlags } from 'utils/features';
import ElementBase from '../base';
import CaptionFooter from '../caption';
import MediaRecording from './MediaRecording';

class MediaRecordingElement extends Component {
  updateCaption = caption => {
    this.props.handleUpdate({ caption });
  };

  render() {
    const seismicAudioElementUploadEnabled = hasFeatureFlags(
      'readiness-enable-seismic-upload-audio-el',
    );

    const seismicAudioElementRecordingEnabled = hasFeatureFlags(
      'readiness-enable-seismic-recording-audio-el',
    );

    const { content } = this.props;
    return (
      <div className="EditorElement-content">
        <div className="EditorElement-body">
          <MediaRecording
            {...this.props}
            seismicAudioElementUploadEnabled={seismicAudioElementUploadEnabled}
            seismicAudioElementRecordingEnabled={
              seismicAudioElementRecordingEnabled
            }
          />
        </div>
        <CaptionFooter
          onChange={this.updateCaption}
          caption={content.caption}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  browserSupport: state.meta.browserSupport,
  currentUserId: state.editor.currentUserId,
});

export default compose(
  connect(mapStateToProps),
  ElementBase,
)(MediaRecordingElement);
